import React from 'react';
import ReportDropDown from '../../components/reportDropDown.jsx';
import {FormattedMessage, intlShape, injectIntl} from 'react-intl';

import {systemTypeNamesFormat} from '../../../../helpers/constants.jsx';

let accountStatus = [];
let missingOptions = [];

class ReportOptions extends React.Component {
  state = {
    accountStatus: 0,
    missingInformation: 0,
    store: 0,
    systemType: 0,
  };

  componentWillMount() {
    let {formatMessage} = this.props.intl;

    accountStatus = [
      {value: 0, label: formatMessage({id: 'general.all'})},
      {value: 1, label: formatMessage({id: 'general.active'})},
      {value: 2, label: formatMessage({id: 'general.inactive'})},
    ];

    missingOptions = [
      {value: 0, label: formatMessage({id: 'general.all'})},
      {value: 1, label: formatMessage({id: 'general.no.contacts'})},
      {value: 2, label: formatMessage({id: 'general.no.addresses'})},
      {value: 3, label: formatMessage({id: 'general.no.emails'})},
      {value: 4, label: formatMessage({id: 'general.no.phones'})},
    ];
  }

  resetFilters = () => {
    this.setState({
      accountStatus: 0,
      missingInformation: 0,
      store: 0,
      systemType: 0,
    });
  };

  updateData = () => {
    this.props.updateReportData(
			this.state.store,
			this.state.systemType,
			this.state.accountStatus,
			this.state.missingInformation,
		);
  };

  render() {

    let stores = [];
    let systemTypes = [];
    let {formatMessage} = this.props.intl;
    let systemTypeNames = systemTypeNamesFormat(formatMessage);

    if(this.props.branches !== null && this.props.branches !== undefined && this.props.branches.length > 0) {
      var obj = this.props.branches;

      stores = Object.keys(obj).map(function(key) {
        return {value: obj[key].id, label: obj[key].name};
      });

      stores.unshift({value: 0, label: formatMessage({id: 'general.all.stores'})});
    }

    systemTypes = Object.keys(systemTypeNames).map(function(key) {
      return {value: key, label: systemTypeNames[key]};
    });
    systemTypes.unshift({value: 0, label: formatMessage({id: 'general.all.systems'})});

    return (
      <div className="report-options">
        <div className="top-title-bar">
          <FormattedMessage id="general.report.options" />
        </div>
        <div className="select-options container-fluid">
          <div className="row">
            <div className="col-sm-3">
              <ReportDropDown value={this.state.store} label={formatMessage({id: 'general.store'})}
							onChange={((e) => {
  this.setState({store: e.target.value});
})}
							options={stores} />
            </div>
            <div className="col-sm-3">
              <ReportDropDown value={this.state.systemType} label={formatMessage({id: 'general.system.type'})}
							onChange={((e) => {
  this.setState({systemType: e.target.value});
})}
							options={systemTypes} />
            </div>
            <div className="col-sm-3">
              <ReportDropDown value={this.state.accountStatus} label={formatMessage({id: 'general.account.status'})}
							onChange={((e) => {
  this.setState({accountStatus: e.target.value});
})}
							options={accountStatus} />
            </div>
            <div className="col-sm-3">
              <ReportDropDown value={this.state.missingInformation} label={formatMessage({id: 'reports.customer.missing.information'})}
							onChange={((e) => {
  this.setState({missingInformation: e.target.value});
})}
							options={missingOptions} />
            </div>
          </div>
        </div>
        <div className="manage-options">
          <div className="col-sm-12 button-group">
            <a className="reset-button pull-right" onClick={this.resetFilters}><FormattedMessage id="general.reset" /></a>
            <a className="btn btn-primary pull-right" onClick={this.updateData}><FormattedMessage id="reports.update.summary" /></a>
          </div>
        </div>
      </div>
    );
  }
}

export default injectIntl(ReportOptions);
